import "core-js/fn/object/assign";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import VueYoutube from "vue-youtube";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
// import VueAnalytics from "vue-analytics";

// Vue.mixin({
//   created: function() {
//     alert("oi from global mixin");
//   }
// });

Vue.use(VueAxios, axios);

Vue.filter("formatDate", function(value) {
  if (value) {
    const splitDate = String(value).split("-");
    return splitDate[2] + "/" + splitDate[1] + "/" + splitDate[0];

    // const date = new Date(String(value));

    // const pad = (num) => {
    //   var s = num + "";
    //   while (s.length < 2) s = "0" + s;
    //   return s;
    // };

    // return (
    //   pad(date.getDate()) +
    //   "/" +
    //   pad(date.getMonth() + 1) +
    //   "/" +
    //   date.getFullYear()
    // );
  }
});

// Vue.use(VueAnalytics, {
//   id: "UA-155289016-1"
// });

Vue.config.productionTip = false;

Vue.use(VueYoutube);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
